// Initialize Sentry FIRST so we capture render-phase errors. No-op when
// REACT_APP_SENTRY_DSN is unset (preview/local).
import { initSentry } from "@/sentry";
initSentry();

// Build-version stamp — lets us verify which deployment is live. Bumped on
// every routing/auth change. Visible in browser console + window.__WAVE_BUILD.
const WAVE_BUILD = "iter-63.5 · 2026-04-28 · root→/login + investor-gate";
window.__WAVE_BUILD = WAVE_BUILD;
// eslint-disable-next-line no-console
console.log("%c WAVE DSP " + WAVE_BUILD, "background:#FF4D94;color:#fff;font-weight:bold;padding:4px 8px;border-radius:4px");

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import AppErrorBoundary from "@/components/AppErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
